import { Button, Container, Group } from '@mantine/core';
import { Logo } from 'moh-ui';
import React from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
    return (
        <header className="border-b border-gray-200 bg-white">
            <Container size="lg" className="py-4">
                <Group justify="space-between" align="center">
                    <Logo
                        title='Republic of Rwanda'
                        subtitle="Rwanda Health Council Connect (RHCC)"
                    />

                    <Group gap="md">
                        <Button
                            component={Link}
                            to="/auth/login"
                            variant="subtle"
                        >
                            Login
                        </Button>
                        <Button
                            component={Link}
                            to="/HomePage"
                            variant="filled"
                        >
                            Create Account
                        </Button>
                    </Group>
                </Group>
            </Container>
        </header>
    );
};

export default Header; 